import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@smyslika/ui-tokens/fonts.css'

import { App } from './App.tsx'
import { installTokens } from './tokens.ts'
import './app.css'
import './ui/ui.css'

// Переменные ставятся до первого кадра, иначе он вышел бы бесцветным.
installTokens()

const root = document.getElementById('root')
if (root == null) throw new Error('нет #root — сломан index.html')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
